import React from "react"
import clockMarkers from "../clockMarkers"

function Clock(props) {
    const markers = clockMarkers.map((value, index) => {
        return (
            <div key={index} className={"numberMarkerWrapper " + value}>
                <div className="numberMarker numberMarkerTop"></div>
                <div className="numberMarker numberMarkerBottom"></div>         
            </div>
        )
    })
    
    return (
        <div className = "clockWrapper">
            <div className = "clockInner"></div>
            {markers}
            <div className="numberMarkerWrapper" id="minuteHandRotate">
                <div className = "clockHand minuteHand"></div>
            </div>
            <div className="numberMarkerWrapper" id="hourHandRotate">
                <div className = "clockHand hourHand"></div>
            </div>

            <div className="middleDot"></div>
        </div>
    )
}

export default Clock